/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbIcon as AbIconInternal } from "abreact/misc/AbIcon";
import * as React from "react";
export function AbIcon(props) {
  return /*#__PURE__*/React.createElement(AbIconInternal, props);
}
//# sourceMappingURL=AbIcon.js.map
